import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie'

const useGetProvidersSummaryPDFURL = () => {
    return async (providersList) => {
        const additionalHeaders = {}

        const csrfTokenCookie = Cookies.get('csrftoken')

        if (csrfTokenCookie) {
            additionalHeaders['X-CSRFToken'] = csrfTokenCookie
        }

        let response;
        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/provider_pdf`,
                {
                    method: 'POST',
                    headers: {
                        'Access-Control-Request-Method': 'POST',
                        'content-type': 'application/json',
                        ...additionalHeaders
                    },
                    body: JSON.stringify({providers: providersList.map(provider => provider.id)})
                }
            );
        } catch (error) {
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `useGetFields - ${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 200) {
            const error = new Error();
            if (response.status) {
                switch (response.status) {
                    case 400:
                    case 415:
                        error.clientStatusMessage = {
                            variant: 'danger',
                            i18nKey: 'error.client-bad-request',
                            source: `${response.status.toString()} ${parsedResponse.detail}`
                        }
                        Sentry.captureException(parsedResponse);
                        break;
                    default:
                        error.clientStatusMessage = {
                            variant: 'danger',
                            i18nKey: 'error.api-bad-response',
                            source: `${response.status.toString()} ${parsedResponse.detail}`
                        }
                        Sentry.captureException(parsedResponse);
                }
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useGetProvidersSummaryPDFURL;
